import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../../apis/data";
import { queryKey } from "../../../enumerations/queryKey";
import { FaqCategoryResponse, FaqResponse } from "../data";
import { apiGetFaqCategory, apiGetFaqList } from "./service";

export const useGetFaq = (options: any) => {
  const generateChild = (_faq: FaqResponse) => {
    return <div dangerouslySetInnerHTML={{ __html: _faq.answer }} />;
  };

  return useQuery<FaqResponse[]>({
    queryKey: [queryKey.FAQ_LIST],
    queryFn: () =>
      apiGetFaqList().then((res: ApiResponse<FaqResponse[]>) => {
        return res.data.data.map((_faq: FaqResponse, index: number) => {
          return {
            ..._faq,
            key: `faq_${index}`,
            label: _faq.question,
            children: generateChild(_faq),
          };
        });
      }),
    ...options,
  });
};

export const useGetFaqCategory = (options: any) => {
  return useQuery<FaqCategoryResponse[]>({
    queryKey: [queryKey.FAQ_CATEGORY_LIST],
    queryFn: () =>
      apiGetFaqCategory().then((res: ApiResponse<FaqCategoryResponse[]>) => {
        return res.data.data;
      }),
    ...options,
  });
};
